<div class="customize-field-text__field-bool">
    <field-type-switch
        [label]="fieldText|afTranslate"
        [checked]="switchOption.model"
        [disabled]="disabled"
        (callback)="changeModel($event.value)">
    </field-type-switch>
</div>
